import { render, staticRenderFns } from "./PreviousReleaseModal.vue?vue&type=template&id=f2c1c23e&scoped=true&"
import script from "./PreviousReleaseModal.vue?vue&type=script&lang=js&"
export * from "./PreviousReleaseModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviousReleaseModal.vue?vue&type=style&index=0&id=f2c1c23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c1c23e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2c1c23e')) {
      api.createRecord('f2c1c23e', component.options)
    } else {
      api.reload('f2c1c23e', component.options)
    }
    module.hot.accept("./PreviousReleaseModal.vue?vue&type=template&id=f2c1c23e&scoped=true&", function () {
      api.rerender('f2c1c23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PreviousReleaseModal.vue"
export default component.exports